<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.requisicao"
            :tbody-tr-class="rowClass"
            class="table-requisicoes"
            sort-by="dataRequisicao"
            search-by="unidadeNomeFantasia"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$router.push({ name: 'almoxarifado-requisicao-pendente-permissao-edit', params: { id: item.id } })"
                    authorize="update-almoxarifado-requisicao-pendente-permissao"
                    color="primary"
                    small
                    title="Responder"
                >
                    <rkm-icon icon="paper-plane" />
                </rkm-button>
            </template>

            <template #afterTable>
                <div class="my-2">
                    <p class="mb-0">
                        A linha em <span class="blue">azul</span> representa que foram reservadas quantidades a conceder
                            para o setor requisitante, mas ainda não foram enviadas.
                    </p>

                    <p>
                        A linha em <span class="yellow">amarela</span> representa que foram enviadas as quantidades
                        concedidas para o setor requisitante, mas a requisição ainda possui quantidades pendentes a
                        serem enviadas.
                    </p>
                </div>
            </template>
        </rkm-data-table>
    </div>
</template>

<script>
// Others.
import { repository } from '@/mixins'

export default {
    computed: {
        fields() {

            return [
                {
                    key: 'dataRequisicao',
                    name: 'requisicao.createdAt',
                    label: 'Data da requisição',
                    class: 'col-min',
                    sortable: true,
                    searchable: true,
                },
                {
                    key: 'unidadeNomeFantasia',
                    name: 'unidade.nomeFantasia',
                    label: 'Unidade',
                    sortable: true,
                    searchable: true,
                },
                {
                    key: 'infraestruturaNome',
                    name: 'infraestrutura.nome',
                    label: 'Local de atendimento',
                    sortable: true,
                    searchable: true,
                },
                {
                    key: 'setorNome',
                    name: 'setor.nome',
                    label: 'Setor',
                    sortable: true,
                    searchable: true,
                },
                {
                    key: 'usuarioNome',
                    name: 'usuario.nome',
                    label: 'Usuário',
                    sortable: true,
                    searchable: true,
                },
                {
                    key: 'numero',
                    name: 'requisicao.numero',
                    label: 'Número',
                    class: 'col-min',
                    sortable: true,
                    searchable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]
        }
    },
    created() {

        this.repositories = {
            requisicao: this.getConectaSusRepository('almoxarifado.requisicaoPendentePermissao')
        }
    },
    data: () => ({
    }),
    methods: {
        async validate() {

            return true
        },
        rowClass(item, type) {

            if (type === 'row' && item && item.iniciouResposta) {

                return `table-${item.possuiEnvioPendente ? 'warning' : 'primary'}`
            }
        },
    },
    mixins: [repository]
}
</script>

<style scoped>
.table-requisicoes >>> .blue { color: blue; }
.table-requisicoes >>> .yellow { color: #e6c619; }
</style>